import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, concatMap, take } from 'rxjs';

import { Invoice } from '../classes/models';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  // May need to modify for Clients.
  getInvoices(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Vendor: () =>
            this.http.get<Invoice[]>(
              `/api/v2/vendor/${this.AuthService.getUserVendorId()}/invoice/many`,
              { params: query }
            ),
          Admin: () =>
            this.http.get<Invoice[]>(`/api/v2/admin/invoice/many`, {
              params: query
            })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  // May need to modify for Clients/Vendors.
  getInvoiceCount(query = {}) {
    return this.AuthService.getUserType().pipe(
      take(1),
      concatMap((userType: string) => {
        const userTypeToObservableMap: {
          [key: string]: () => Observable<any>;
        } = {
          Vendor: () =>
            this.http.get<Invoice[]>(
              `/api/v2/vendor/${this.AuthService.getUserVendorId()}/invoice/count`,
              { params: query }
            ),
          Admin: () =>
            this.http.get<number>(`/api/v2/admin/invoice/count`, {
              params: query
            })
        };

        if (userTypeToObservableMap[userType]) {
          return userTypeToObservableMap[userType]();
        }

        throw this.ToastService.addErrorToast('Error', 'Invalid permission.', {
          returnError: true
        });
      })
    );
  }

  saveInvoice(Invoice: Invoice, query = {}) {
    return this.http.post<Invoice>(`/api/v2/admin/invoice`, Invoice, {
      params: query
    });
  }
}
